import { render, staticRenderFns } from "./ProbelGetPatientToken.vue?vue&type=template&id=1a73b348"
import script from "./ProbelGetPatientToken.vue?vue&type=script&lang=js"
export * from "./ProbelGetPatientToken.vue?vue&type=script&lang=js"
import style0 from "./ProbelGetPatientToken.vue?vue&type=style&index=0&id=1a73b348&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports